import { ExternalLinkIcon } from '@/assets/icons'
import BrandMark from '@components/BrandMark'
import React from 'react'
import { Brand, CtaButton, HeaderBar, HeaderInner, HeaderRight, PillPrefix, ReadOnlyPill } from './SiteHeader.styles'
import { iconSizes } from '@/theme/tokens'

interface SiteHeaderProps {
	/** Marketing / app-store link the "Get Orbit free" button opens. */
	getOrbitUrl: string
}

/**
 * The public Shared-trip page header (marketing chrome, public mode only): the
 * shared `BrandMark` lockup, a "Shared trip · view only" read-only pill, and
 * the indigo "Get Orbit free" CTA. Sticky, cream background per the handoff.
 */
const SiteHeader: React.FC<SiteHeaderProps> = ({ getOrbitUrl }) => (
	<HeaderBar>
		<HeaderInner>
			<Brand href={getOrbitUrl} target="_blank" rel="noreferrer" aria-label="Orbit">
				<BrandMark />
			</Brand>
			<HeaderRight>
				<ReadOnlyPill>
					<ExternalLinkIcon sx={{ fontSize: iconSizes.xs }} aria-hidden="true" />
					<PillPrefix>Shared trip · </PillPrefix>view only
				</ReadOnlyPill>
				<CtaButton as="a" href={getOrbitUrl} target="_blank" rel="noreferrer">
					Get Orbit free
				</CtaButton>
			</HeaderRight>
		</HeaderInner>
	</HeaderBar>
)

export default SiteHeader
